<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background">

  <!-- Form Page Heading -->
  @if (formConfig.pages[currentPage]?.showPageHeader) {
    <h1 class="form-heading">
    {{formConfig.pages[currentPage]?.pageHeader}}</h1>
  }

  <!-- Form Entries Loop -->
  @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
    <div class="form-row"
      [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
      <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [formConfig]="formConfig">
      </ptl-entry-as-json>
    </div>
  }

  @if (!isQualified) {
    <div class="error-msg">
      You are not currently eligible to enroll, please contact a Medicare advisor at <a href="tel:1-844-593-0265">1-844-593-0265</a> for details.
    </div>
  }

  <!-- Form Page Nav BUTTONS -->
  <div class="form-buttons">

    <div class="navigational-controls">
      @if (currentPage !== 0) {
        <div class="nav-link">
          <a href="javascript:void(0)" (click)="backButton()">
            <span class="material-symbols-outlined">arrow_back</span>
            <span class="text left-text">BACK</span>
          </a>
        </div>
      }

      @if (currentPage !== formConfig.pages.length - 1) {
        <div class="nav-link spacer">
          @if (!isLoading) {
            <a href="javascript:void(0)" (click)="nextButton()"
              [ngClass]="{'disable-link' : formConfig.form.formNavigation.nextButton.disable }">
              <span class="text">NEXT</span>
              <span class="material-symbols-outlined">arrow_forward</span>
            </a>
          }
          @if (isLoading) {
            <mat-spinner [diameter]="25"></mat-spinner>
          }
        </div>
      }
    </div>

    @if (currentPage === formConfig.pages.length - 1) {
      <button mat-raised-button color="primary" class="submit-button" (click)="submitButton()">
        SUBMIT
      </button>
    }

  </div>

</div>